module.exports = __webpack_public_path__ + "img/Ja, inbrekers.f80297ca.png";